import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Card } from "@/Components/ui/card"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/Components/ui/tabs";
import PlanPage from "@/Components/Training/PlanPage";
import CharterPage from "@/Components/Training/CharterPage";
import MenuPage from "@/Components/Training/MenuPage";
import RiskPage from "@/Components/Training/RiskPage";
import ActionPage from '@/Components/Training/ActionPage';
import IssuePage from '@/Components/Training/IssuePage';
import DecisionPage from '@/Components/Training/DecisionPage';
import SupportPage from '@/Components/Training/SupportPage';
import DashboardPage from '@/Components/Training/DashboardPage';
import { useResponsiveZoom } from "@/hooks/use-responsive-zoom";
import { useIsMobile } from "@/hooks/use-mobile";



const Training = () => {
    const defaultTab = "menu";
    const [tab, setTab] = useState(defaultTab);
    const onTabChange = (value: string) => {
        setTab(value);
    };

    const { state } = useLocation();
    const zoomLevel = useResponsiveZoom();
    const isMobile = useIsMobile();

    const tabs = [
        "menu",
        "dashboard",
        "charter",
        "plan",
        "risk",
        "action",
        "issue",
        "decision",
        "support"
    ];

    React.useEffect(() => {
        setTab(state?.tab || defaultTab);
        const down = (e: KeyboardEvent) => {
            if (e.key === "PageUp" && (e.shiftKey)) {
                e.preventDefault()
                handleNavigateTabs(-1);
            }
            else if (e.key === "PageDown" && (e.shiftKey)) {
                e.preventDefault()
                handleNavigateTabs(1);
            }
        }
        document.addEventListener("keydown", down)
        return () => document.removeEventListener("keydown", down)
    }, []);

    const handleNavigateTabs = (val: number) => {
        setTab((prevTab) => {
            let index = tabs.indexOf(prevTab);
            index += val;
            if (index < 0) {
                index = tabs.length - 1;
            } else if (index >= tabs.length) {
                index = 0;
            }
            return tabs[index];
        });
    }

    if (isMobile) {
        return (
            <Card className="flex flex-col items-center p-2 mx-auto w-[95%]" style={{ zoom: zoomLevel }}>
                <h1 className="text-3xl font-bold m-4 mx-auto">Mobile Help Coming Soon...</h1>
            </Card>
        );
    }

    return (
        <Card className="flex flex-col items-center p-2 m-2" style={{ zoom: zoomLevel }}>
            <Tabs value={tab} onValueChange={onTabChange} defaultValue={defaultTab} className="w-full p-4">
                <TabsList>
                    <TabsTrigger value="menu">Menu</TabsTrigger>
                    <TabsTrigger value="dashboard">Dashboard</TabsTrigger>
                    <TabsTrigger value="charter">Charter</TabsTrigger>
                    <TabsTrigger value="plan">Plan</TabsTrigger>
                    <TabsTrigger value="risk">Risk</TabsTrigger>
                    <TabsTrigger value="action">Action</TabsTrigger>
                    <TabsTrigger value="issue">Issue</TabsTrigger>
                    <TabsTrigger value="decision">Decision</TabsTrigger>
                    <TabsTrigger value="support">Support</TabsTrigger>
                </TabsList>
                <TabsContent value="menu">
                    <MenuPage />
                </TabsContent>
                <TabsContent value="dashboard">
                    <DashboardPage />
                </TabsContent>
                <TabsContent value="plan">
                    <PlanPage />
                </TabsContent>
                <TabsContent value="charter">
                    <CharterPage showWizardLinks={ false }  />
                </TabsContent>
                <TabsContent value="risk">
                    <RiskPage />
                </TabsContent>
                <TabsContent value="action">
                    <ActionPage />
                </TabsContent>
                <TabsContent value="issue">
                    <IssuePage />
                </TabsContent>
                <TabsContent value="decision">
                    <DecisionPage />
                </TabsContent>
                <TabsContent value="support">
                    <SupportPage />
                </TabsContent>
            </Tabs>
        </Card>
    )
}

export default Training